import React from 'react';
import './WorkingProcess.css';
// import businessImage from '../../public/logo.png'; // 请确保有这个图片或替换为您的图片路径

function WorkingProcess() {
  return (
    <div className="working-process-container">
      <div className="working-process-header">
        <h2 className="title">The Advantages of Investing with Cyberate NZ<span className="dot">.</span></h2>
        <p className="description" style={{color: '#91268F'}}>
          Our exclusive property development investment analysis system has been successfully validated in overseas markets and has been tailored with localized data training for the New Zealand market.
        </p>
      </div>

      <div className="working-process-timeline-container">
        <div className="timeline">
          <div className="timeline-line"></div>
          <div className="timeline-dot active" style={{top: '15%'}}></div>
          <div className="timeline-dot active" style={{top: '50%'}}></div>
          <div className="timeline-dot active" style={{top: '85%'}}></div>
        </div>

        <div className="process-steps-container">
          {/* Step 1 */}
          <div className="process-steps">
            <div className="process-step active">
              <span className="step-number">Advantage 1</span>
              <h3 className="step-title">No Need to Read Through Complex Regulations – Instant Policy Overview</h3>
              <p className="step-description">
                Save days of legal research time per project. Automatically updates and consolidates council regulations, providing key information at a glance.
              </p>

              <div className="process-cards">
                <div className="process-card">
                  <h4>Time Efficiency</h4>
                  <p>Saves days of legal research time for each project.</p>
                </div>
                <div className="process-card">
                  <h4>Information Integration</h4>
                  <p>Automatically updates and consolidates council regulations, providing key information at a glance.</p>
                </div>
              </div>

              
            </div>

            <div className="process-image">
              <img src='/images/advantages/image.png' alt="Policy Overview" />
            </div>
          </div>

          {/* Step 2 */}
          <div className="process-steps">
            <div className="process-step">
              <span className="step-number">Advantage 2</span>
              <h3 className="step-title">Real-Time Image Scanning – Instantly Identify Land Risks</h3>
              <p className="step-description">
                Utilising satellite data to analyse and scan project sites, we can proactively identify potential risks or planning restrictions. This enables early risk mitigation and reduces unexpected costs.
              </p>

              <div className="process-cards">
                <div className="process-card">
                  <h4>Risk Identification</h4>
                  <p>Using satellite data to scan project sites, we can detect potential risks or planning restrictions in advance.</p>
                </div>
                <div className="process-card">
                  <h4>Cost Control</h4>
                  <p>Proactively mitigating risks to reduce unexpected costs.</p>
                </div>
              </div>

              
            </div>

            <div className="process-image">
              <img src='/images/advantages/image1.png' alt="Land Scanning" />
            </div>
          </div>

          {/* Step 3 */}
          <div className="process-steps">
            <div className="process-step">
              <span className="step-number">Advantage 3</span>
              <h3 className="step-title">Efficient Data-Driven Site Selection – No More Location Worries</h3>
              <p className="step-description">
                With one-click, all available properties nationwide—2 days faster than traditional methods. Using cost, location, and development potential as key criteria, we precisely identify high-return land opportunities.
              </p>

              <div className="process-cards">
                <div className="process-card">
                  <h4>Search Efficiency</h4>
                  <p>Instantly search nationwide available properties, significantly faster than traditional methods by 2 days.</p>
                </div>
                <div className="process-card">
                  <h4>Precise Matching</h4>
                  <p>Using budget, location, and development potential as multi-dimensional filters, we accurately pinpoint high-return land opportunities.</p>
                </div>
              </div>

              
            </div>

            <div className="process-image">
              <img src='/images/advantages/image2.png' alt="Data Filtering" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkingProcess; 